const getAdocUrlFromOctetStream = async (url: string) => {
  if(!url) return new Error('No URL');

  try {
    const response = await fetch(url);
    const octetStreamBlob = await response.blob();
    const downloadUrl = URL.createObjectURL(octetStreamBlob);

    return downloadUrl;
  }
  catch (error) {
    return new Error("Something went wrong");
  }
}

export {getAdocUrlFromOctetStream};